export default "__VITE_ASSET__Cbc9GJhh__"